import { getCore as get, postCore as post } from "../../utils/httpInterceptor";

class MeService {
  static _meInFlight = null;
  static _meCache = null;
  static _meCacheAt = 0;
  static _meCacheTtlMs = 5000;

  static async me() {
    const now = Date.now();

    // Evitar tormentas de requests si algún componente re-renderiza en bucle.
    if (MeService._meCache && now - MeService._meCacheAt < MeService._meCacheTtlMs) {
      return MeService._meCache;
    }

    if (MeService._meInFlight) {
      return MeService._meInFlight;
    }

    MeService._meInFlight = (async () => {
      try {
        const data = await get("/api/me");
        MeService._meCache = data;
        MeService._meCacheAt = Date.now();
        return data;
      } finally {
        MeService._meInFlight = null;
      }
    })();

    return MeService._meInFlight;
  }

  static async switchTenant(tenantId) {
    return await post("/api/me/switch-tenant", { tenantId });
  }
}

export default MeService;
